import { emptyValue } from "./Utils";


export function saveSc(taskId:number, inputId:number, input:HTMLElement){

    const item = $(input).find("input:checked");
    const answer = (item.length > 0) ? parseInt(item.val().toString()) : emptyValue;

    return {answer: answer};


}